import { render } from "./dyhd.vue?vue&type=template&id=2382c17c&scoped=true&ts=true"
import script from "./dyhd.vue?vue&type=script&lang=ts"
export * from "./dyhd.vue?vue&type=script&lang=ts"

import "./dyhd.vue?vue&type=style&index=0&id=2382c17c&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2382c17c"]])

export default __exports__